<template>
    <div>
        <section class="content-header">
            <h1>
                Vehículos
                <small>Búsqueda de vehículos</small>
            </h1>
        </section>
        <section class="content">

            <div class="container-fluid">
                <!-- basic data vehicle box -->
                <div class="box box-default box-basic-data">
                    <!-- /.box-header -->
                    <!-- .box-body -->
                    <div class="box-body">
                        <carfactory-dealer-quota-component></carfactory-dealer-quota-component>
                    </div>
                </div>

                <!-- basic data vehicle box -->
                <div class="box box-default box-basic-data">
                    <!-- /.box-header -->
                    <!-- .box-body -->
                    <div class="box-body">
                        <p class="text-center">
                            <strong>Búsqueda de vehículos</strong>
                        </p>
                        <search-filters></search-filters>
                        <search-cars-datatable></search-cars-datatable>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
import SearchCarsDatatable from './CarsSearch/SearchCarsDatatable'
import CarfactoryDealerQuotaComponent from '@/components/custom/CarfactoryDealerQuotaComponent'
import SearchFilters from '@/components/custom/SearchFilters'
export default {
  name: 'PageCarSearchComponent',
  components: {SearchFilters, CarfactoryDealerQuotaComponent, SearchCarsDatatable}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PageCarSearchComponent.vue